import {
  CandleFetchParams,
  CandlePoint,
  ExchangeCandleRestAdapter,
} from "../../candle.types";
import { toBinanceInterval } from "../../candle-intervals";
import { normalizeCandleSymbol } from "../../candle-symbols";
import { dedupeCandles } from "./rest-adapter.utils";

type AsterKline = [number, string, string, string, string, string];

const ASTER_KLINES_URL = "https://fapi.asterdex.com/fapi/v3/klines";
const DEFAULT_LIMIT = 500;
const MAX_LIMIT = 1500;

export const asterdexCandlesRestAdapter: ExchangeCandleRestAdapter = {
  async fetchCandles(params: CandleFetchParams): Promise<CandlePoint[]> {
    const symbol = normalizeCandleSymbol("asterdex", params.symbol);
    const query = new URLSearchParams({
      symbol,
      interval: toBinanceInterval(params.interval),
      limit: String(Math.min(params.limit ?? DEFAULT_LIMIT, MAX_LIMIT)),
    });
    if (params.startTime) query.set("startTime", String(params.startTime));
    if (params.endTime) query.set("endTime", String(params.endTime));

    const response = await fetch(`${ASTER_KLINES_URL}?${query.toString()}`);
    if (!response.ok) {
      throw new Error("Price chart is temporarily unavailable");
    }

    const payload = (await response.json()) as AsterKline[] | { code?: number };
    if (!Array.isArray(payload)) return [];

    return dedupeCandles(
      payload.map((kline) => ({
        startTime: kline[0],
        openPrice: kline[1],
        highPrice: kline[2],
        lowPrice: kline[3],
        closePrice: kline[4],
        volume: kline[5],
      }))
    );
  },
};
